module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Daten Personalien 1-88cf2738f1a852a72fb756e08d177e56.png";